import { useHotkeys } from 'react-hotkeys-hook'

interface CustomerHotkeysActions {
	onQuickLock: () => void
	onBatchWechat: () => void
	onBatchMobile: () => void
}

/**
 * 客户模块全局快捷键
 * - Alt+Q: 快速锁定
 * - Alt+Z: 批量检查微信
 * - Alt+X: 批量检查手机
 */
export function useCustomerHotkeys(actions: CustomerHotkeysActions) {
	// Alt+Q - 快速锁定
	useHotkeys('alt+q', (e) => {
		e.preventDefault()
		actions.onQuickLock()
	}, { enableOnFormTags: true })

	// Alt+Z - 批量检查微信
	useHotkeys('alt+z', (e) => {
		e.preventDefault()
		actions.onBatchWechat()
	}, { enableOnFormTags: true })

	// Alt+X - 批量检查手机
	useHotkeys('alt+x', (e) => {
		e.preventDefault()
		actions.onBatchMobile()
	}, { enableOnFormTags: true })
}
